// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__H0rrj","title":"ClientReferral_title__2R0eU","itemText":"ClientReferral_itemText__2VxUm"};